/* Decor Walay — featured-showcase.js
   Slider behavior for the gallery: prev/next arrows, dot navigation,
   and optional autoplay (pauses on hover). */

document.addEventListener('DOMContentLoaded', function () {
  Array.prototype.slice.call(document.querySelectorAll('[data-showcase-gallery]')).forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.featured-showcase__slide'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-showcase-dot]'));
    var current = 0;
    var autoplay = gallery.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(gallery.getAttribute('data-autoplay-speed'), 10) || 4000;
    var timer = null;

    var prevBtn = gallery.querySelector('[data-showcase-prev]');
    var nextBtn = gallery.querySelector('[data-showcase-next]');

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});
